import { computed } from 'vue'
import { generateColors } from '../utils/generateColors'

export function useChartColors(series, legendItems) {
  return computed(() => {
    const seriesArray = Array.isArray(series.value) ? series.value : []

    const colors = seriesArray.map(serie => {
      const legend = legendItems.value?.find(item => item.name === serie.name)
      return legend ? legend.color : null
    })

    const missingCount = colors.filter(c => !c).length
    if (missingCount > 0) {
      const generatedColors = generateColors(missingCount)
      let i = 0
      return colors.map(color => color || generatedColors[i++])
    }

    return colors
  })
}